export default __webpack_public_path__ + "static/media/xerius-error.1eeea60d.png";